// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:47:49

export default {
  "id": "winter-wolf",
  "slug": "winter-wolf",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cb801674259e4640b677139a1427f768-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cb801674259e4640b677139a1427f768/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Winter Wolf",
      "description": "Winter has come, and the snowfall has begun. Since it's Christmas time, the wolf must find three stars during the winter. The wolf needs to carefully hunt and catch three sheep, take their stars, and gather all the bones on the path to avoid starving. It must also be cautious of the hunters in the forest. At the end of the level, it must reach the dark portal to teleport to its desired location.",
      "instructions": "*Use the \"WASD\" keys to move. \n*Double Jump is active. \n*Collect all 3 stars and bones to activate the dark portal.",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "1player",
        "2d",
        "christmas",
        "minecraft",
        "pixel"
      ]
    },
    "zh-CN": {
      "title": "冬日狼",
      "description": "寒冬已至，雪已经开始下。由于是圣诞节，狼必须在这个冬天找到三颗星星。狼需要仔细狩猎并捕捉三只羊，拿走它们的星星，并收集路径上的所有骨头以避免饥饿。它还必须小心森林中的猎人。在关卡结束时，它必须到达黑暗传送门，以传送至其心仪的位置。",
      "instructions": "*使用“WASD”键进行移动。\n*双跳已激活。\n*收集所有3颗星星和骨头以激活黑暗传送门。",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "2D",
        "圣诞节",
        "我的世界",
        "像素"
      ]
    },
    "zh-TW": {
      "title": "冬季狼",
      "description": "寒冬已至，降雪開始。由於是聖誕節，狼必須在冬季找到三顆星星。狼需要謹慎地尋找並捕捉三隻羊，取走他們的星星，並在路徑上收集所有骨頭以避免饑餓。它還必須小心森林中的獵人。在關卡結束時，它必須到達黑暗通道以傳送至其目標地點。",
      "instructions": "*使用\"WASD\"鍵來移動。\n*雙重跳躍已啟用。\n*收集所有3顆星星和骨頭以啟動黑暗通道。",
      "genres": [
        "戰鬥",
        "隨意"
      ],
      "tags": [
        "1 玩家",
        "2D,耶诞節,麥克風,像素"
      ]
    },
    "zh-HK": {
      "title": "冬日狼",
      "description": "冬日來臨，雪已開始降下。由於是聖誕節，狼必須在冬日找到三顆星星。狼需要小心尋找並捕捉三隻羊，取走他們的星星，並在路途中收集所有骨頭以避免饑餓。它還必須小心森林中的獵人。在等級結束時，它必須達到黑暗通道以傳送至其期望的位置。",
      "instructions": "*使用「WASD」鍵盤移動。\n*雙跳已啟用。\n*收集所有3顆星星和骨頭以啟動黑暗通道。",
      "genres": [
        "戰鬥",
        "休閒"
      ],
      "tags": [
        "1玩家",
        "2D",
        "聖誕節",
        "Minecraft",
        "像素"
      ]
    },
    "ja": {
      "title": "冬狼",
      "description": "冬が来た。雪が降り始めた。クリスマスの季節だから、オオカミは冬の中で三つの星を見つけなければならない。オオカミは慎重に羊を狩り、星を手に入れ、道の骨を集め、餓死を避けなければならない。また、森の猟師にも注意を払わなければならない。レベルの終わりに、暗いポータルに到達し、望む場所にテレポートしなければならない。",
      "instructions": "*“WASD”キーを使用して移動してください。\n*ダブルジャンプが有効です。\n*3つの星と骨を全て集めることでダークポータルを活性化します。",
      "genres": [
        "バトル",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "クリスマス",
        "マインクラフト",
        "ピクセル"
      ]
    },
    "ko": {
      "title": "겨울의狼",
      "description": "겨울이 왔고 눈이 시작되었습니다. 크리스마스 시간이므로, 늑대는 겨울 동안 세 개의 별을 찾아야 합니다. 늑대는 신중하게 사냥하고 세 마리의 양을 잡아 별을 가져오고, 도로 위의 모든 뼈를 모아 가난을 피해야 합니다. 또한 숲 속의 사냥꾼을 조심해야 합니다. 레벨의 끝에 어둡은 포털에 도달하여 원하는 위치로 전송되어야 합니다.",
      "instructions": "* \"WASD\" 키를 사용하여 이동하세요. \n* 더블 점프가 활성화되었습니다. \n* 모든 3개의 별과 뼈를 모아서 다크 포털을 활성화하세요.",
      "genres": [
        "전투",
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "크리스마스",
        "마인크래프트",
        "픽셀"
      ]
    },
    "fr": {
      "title": "Loup d'Hiver",
      "description": "L'hiver est arrivé, et la neige commence à tomber. Puisque c'est le temps des fêtes, le loup doit trouver trois étoiles pendant l'hiver. Le loup doit chasser et attraper trois moutons avec soin, prendre leurs étoiles, et rassembler tous les os sur le chemin pour éviter de mourir de faim. Il doit également être prudent des chasseurs dans la forêt. À la fin du niveau, il doit atteindre le portail sombre pour se téléporter à son emplacement désiré.",
      "instructions": "*Utilisez les touches \"WASD\" pour vous déplacer.\n*Le double saut est activé.\n*Collectez les 3 étoiles et les os pour activer le portail sombre.",
      "genres": [
        "Bataille",
        "Loisir"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "Noël",
        "Minecraft",
        "pixel"
      ]
    }
  }
};
